export const formatPrice = (price: number) => (price / 100).toFixed(2);
